var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-config-content"},[_c('h4',[_vm._v(_vm._s(_vm.$t('moh')))]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('recording-select',{attrs:{"client-id":_vm.client._id,"model":_vm.client,"attribute":"moh","errors":_vm.formErrors}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }